module.exports = __webpack_public_path__ + "img/thumb_09.66051e41.jpg";